<template>
  <div class="page flex-col ">
    <div class="box_w1 flex-col">
      <div class="text-wrapper_1 flex-col">
        <span class="text_1">开运动处方找以动就够了</span>
     
        <span class="paragraph_1">
          请使用电脑浏览器输入网址&nbsp;“yd-tool.ktangtang.com”&nbsp;
          <br />
          或搜索&nbsp;“以动健康官网”&nbsp;获取七天免费试用
        </span>
      </div>
      <div class="group_1 flex-col">
        <div class="image-wrapper_1 flex-row">
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG7ba570a83befcbe064b13fb9d24088c8.png'"
          />
          <img
            class="image_2"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG6a94e3f80b0a881a2f82b16ad3e3a8f8.png'"
          />
          <div style="margin-left: -32vw;margin-top:-8.2vw"> <headerMask/> </div>
        </div>
      </div>
      <img
        class="image_c2"
        referrerpolicy="no-referrer"
        src="https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNGdc08c5df24df8cd8f86db6a6a0cb1652.png"
      />
    </div>
    <div class="box_2 flex-col">
      <span class="text_3">开运动处方找以动就够了</span>
      <div class="group_2 flex-col">
        <div class="box_3 flex-row justify-between">
          <div class="text-group_1 flex-col justify-between">
            <span class="text_4">3000+</span>
            <span class="text_5">不同运动方式模块</span>
          </div>
          <div class="text-group_2 flex-col justify-between">
            <span class="text_6">200+</span>
            <span class="text_7">骨科运动康复评估方法</span>
          </div>
        </div>
        <div class="box_4 flex-row justify-between">
          <div class="text-group_3 flex-col justify-between">
            <span class="text_8">50+</span>
            <span class="paragraph_2">
              骨科、三高慢性病精神疾病
              <br />
              康复方案及相关数字疗法软件
            </span>
          </div>
          <div class="text-group_4 flex-col justify-between">
            <span class="text_9">70+</span>
            <span class="text_10">肌肉群组的训练及拉伸</span>
          </div>
        </div>
      </div>
      <div class="text-wrapper_2">
        <span class="paragraph_3">
          信任来自于康复计划的来源&nbsp;
          <br />
        </span>
        <span class="text_11">优质的运动康复计划来自于三甲医院的临床实验</span>
      </div>
      <img
        class="image_3"
        referrerpolicy="no-referrer"
        v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNGdf8775e5fe6a9158153082f6b90f7d8b.png'"
      />
      <span class="text_12">301防跌倒多学科联合门诊</span>
      <div class="group_3 flex-row justify-between">
        <div class="image-wrapper_2 flex-col justify-center align-center">
          <img
            class="image_4"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/p12.png'"
          />
       
        </div>
        <div class="block_1 flex-col"> <i class="el-icon-caret-bottom" style="font-size: 8vw;color: rgba(71, 186, 176, 1);"></i></div>
       
      </div>
      <span class="text_13">来自于处方数据库内容，详细内容请登录查看</span>
      <div class="text-wrapper_3">
        <span class="text_14">三大</span>
        <span class="paragraph_4">
          核心功能
          <br />
        </span>
        <span class="text_15">为您的患者</span>
        <span class="text_16">定制运动康复计划</span>
      </div>
      <div class="group_4 flex-row">
        <div class="image-text_1 flex-col justify-between">
          <div class="image-wrapper_3 flex-row justify-between">
            <img
              class="image_5"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG704f1a14634ceff17fbf18d9351c4924.png'"
            />
            <img
              class="image_6"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG3f64ee39aa1088546b57ef8802fa1960.png'"
            />
          </div>
          <div class="text-group_5 flex-row justify-between">
            <span class="text_17">中日友好医院</span>
            <span class="text_18">北京大兴清源路街道养老社区</span>
          </div>
        </div>
        <div class="section_1 flex-col justify-between">
          <img
            class="image_6"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG3f64ee39aa1088546b57ef8802fa1960.png'"
          />
          <span class="text_18">北京大兴清源路街道养老社区</span>
        </div>
        <div class="section_2 flex-col justify-between">
          <img
            class="image_7"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG84317e40ff675c6c40447c4ab60c72cc.png'"
          />
          <span class="text_19">北京聚陆医疗</span>
        </div>
      </div>
      <div class="group_5 flex-row">
        <div class="section_3 flex-col"></div>
        <img
          class="thumbnail_1"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/c43ac978a0094f6b96be4d499e410534_mergeImage.png'"
        />
        <div class="image-text_2 flex-row justify-between">
          <div class="box_5 flex-col">
            <div class="box_6 flex-col"></div>
            <span class="text-group_6">使用机构</span>
          </div>
          <div class="image-wrapper_4 flex-col">
            <img
              class="thumbnail_2"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG0efce337b16177f7b543ef01704cf6f6.png'"
            />
          </div>
        </div>
      </div>
      <div class="group_6 flex-row">
        <div class="image-text_3 flex-col justify-between">
          <div class="image-wrapper_5 flex-col">
            <img
              class="image_8"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG2fbf7c11805554d73e846b7b0f4b3aef.png'"
            />
          </div>
          <span class="text-group_7">南方医科大</span>
        </div>
        <div class="image-text_4 flex-col justify-between">
          <img
            class="image_9"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG21013959cf5c79221306a6b3327b8268.png'"
          />
          <span class="text-group_8">北京大学人民医院</span>
        </div>
        <div class="image-text_5 flex-col justify-between">
          <img
            class="image_10"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNGf2dc5ad3f281e8a1a20076881a8799f1.png'"
          />
          <span class="text-group_9">
            首都医科大学附属
            <br />
            北京安定医院
          </span>
        </div>
      </div>
      <div class="group_7 flex-row">
        <div class="image-text_6 flex-col justify-between">
          <img
            class="image_11"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNGa92464ac282f88ef7ba4f01d489efad9.png'"
          />
          <span class="text-group_10">
            首都医科大学
            <br />
            北京朝阳医院
          </span>
        </div>
        <div class="image-text_7 flex-col justify-between">
          <img
            class="image_12"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG4134d4fe9f042276b09cea826acf1d45.png'"
          />
          <span class="text-group_11">中日友好医院</span>
        </div>
        <div class="box_7 flex-col justify-between">
          <div class="block_2 flex-col">
            <div class="image-wrapper_6 flex-col">
              <img
                class="image_13"
                referrerpolicy="no-referrer"
                v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNGc2fc5c98241879f8c9a0d9271c01c855.png'"
              />
            </div>
          </div>
          <span class="paragraph_5">
            北京医院
            <br />
            （国家老年医学中心）
          </span>
        </div>
      </div>
      <div class="group_8 flex-col">
        <div class="text-wrapper_4 flex-col"  @click="toTools"><span class="text_20">立即领取</span></div>
        <span class="paragraph_6">
          立即领取7天免费试用+美国注册物理康复师主讲
          <br />
          价值4999元的运动康复课
        </span>
      </div>
   
      <div class="group_9 flex-col">
        <div class="group_10 flex-row justify-between">
          <div class="image-text_8 flex-col justify-between">
            <img
              class="image_14"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG0f328a0eda088e99d292007d1745409f.png'"
            />
            <div class="text-group_12">
              <span class="text_22">康复</span>
              <span class="text_23">评估</span>
              <span class="text_24">助手</span>
            </div>
          </div>
          <div class="image-text_9 flex-col justify-between">
            <img
              class="image_15"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG779dd6d0aa1c0912c586a2619fb9ccb3.png'"
            />
            <div class="text-group_13">
              <span class="text_25">康复</span>
              <span class="text_26">处方</span>
              <span class="text_27">助手</span>
            </div>
          </div>
          <div class="image-text_10 flex-col justify-between">
            <img
              class="image_16"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNGfad1e7a5d1cdf3758c9e3b456e9daf5c.png'"
            />
            <div class="text-group_14">
              <span class="text_28">康复</span>
              <span class="text_29">病历</span>
              <span class="text_30">助手</span>
            </div>
          </div>
        </div>
        <div class="group_11 flex-col"><i class="el-icon-caret-bottom" style="font-size: 6vw;color: rgba(71, 186, 176, 1);"></i></div>
        <div class="group_12 flex-row justify-between">
          <div class="group_13 flex-row">
            <div class="text-wrapper_5">
              <span class="paragraph_7">
                患者通过小程序
                <br />
                接受指令
                <br />
              </span>
              <span class="text_31">完成评估和康复计划</span>
            </div>
            <div class="section_4 flex-col"><i class="el-icon-caret-bottom" style="font-size: 6vw;color: rgba(71, 186, 176, 1);"></i></div>
          </div>
          <div class="group_14 flex-col justify-between">
            <div class="text-wrapper_6">
              <span class="paragraph_8">
                历时4年
                <br />
              </span>
              <span class="text_32">20余位中美专家</span>
              <span class="paragraph_9">
                研发
                <br />
              </span>
              <span class="text_33">30家顶尖医院</span>
              <span class="text_34">临床验证</span>
            </div>
            <div class="text-wrapper_7">
              <span class="text_35">2000</span>
              <span class="paragraph_10">
                位治疗师使用
          
              </span>
              <span class="text_36">20000</span>
              <span class="text_37">位患者受益</span>
            </div>
          </div>
        </div>
        <div class="text-wrapper_8">
          <span class="text_38">著名三甲</span>
          <span class="text_39">医院专科和私立康复</span>
          <span class="text_40">机构的选择</span>
        </div>
        <img
          class="image_17"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG36c7a9581f4d9db6bd3870f1973bd9d2.png'"
        />
      </div>
      <div class="group_15 flex-col"></div>
      <div class="group_16 flex-col"><i class="el-icon-caret-bottom" style="font-size: 8vw;color: rgba(71, 186, 176, 1);"></i></div>
    </div>
    <footerMask/>
    <img
      class="image_20"
      referrerpolicy="no-referrer"
      v-lazy="'https://web-cdn.ktangtang.com/official-website/re_ass/FigmaDDSSlicePNG36f687d7a1e324e88c0e7a2e52d37b75.png'"
    />
    <div class="box_9 flex-col">
      <div class="text-wrapper_15">
        <span class="text_54">以动</span>
        <span class="text_55">健康助手</span>
      </div>
      <div class="text-wrapper_16 flex-col"><span class="text_56">2023年度运动康复圈不能错过的软件</span></div>
    </div>

  </div>
</template>
<script>
import headerMask from "../../components/headery";
import footerMask from "../../components/footert";

export default {
  components: {
    headerMask,
    footerMask
  },
  data() {
    return {
      constants: {}
    };
  },
  async mounted() {
    
    let weight = window.screen.width
    console.log(weight, 'ddddddddddddd')
    if(weight >= 1200){
      this.$router.push({path: '/re_as'})
    }
  
  },
  methods: {
    toTools(){
          window.location.href=  'https://yd-tool.ktangtang.com/login'
        }
  }
};
</script>
<style scoped lang="css" src="./assets/index.response.css" />